// src/components/AdminRoute.js
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth);

  if (!user) return <Navigate to="/signin" replace />;

  if (user.role !== "admin") return <Navigate to="/" replace />;

  return children;
};

export default AdminRoute;
